var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8337 2.02175L5.17783 8.68342L2.70449 6.21008L3.52699 5.38758L5.17783 7.03841L11.0112 1.20508L11.8337 2.02175ZM10.5445 4.96175C10.6203 5.29425 10.667 5.64425 10.667 6.00008C10.667 8.57841 8.57866 10.6667 6.00033 10.6667C3.42199 10.6667 1.33366 8.57841 1.33366 6.00008C1.33366 3.42175 3.42199 1.33341 6.00033 1.33341C6.92199 1.33341 7.77366 1.60175 8.49699 2.06258L9.33699 1.22258C8.39199 0.557581 7.24283 0.166748 6.00033 0.166748C2.78033 0.166748 0.166992 2.78008 0.166992 6.00008C0.166992 9.22008 2.78033 11.8334 6.00033 11.8334C9.22033 11.8334 11.8337 9.22008 11.8337 6.00008C11.8337 5.30591 11.7053 4.64091 11.4837 4.02258L10.5445 4.96175Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/DoneIcon.144974267fd959053778cc863d8ef60e.svg";
export { ForwardRef as ReactComponent };